export const SITE_DATA = {
  logo: "/LOGO OK .PNG",
  hero: {
    bgImages: ["/ponte principe LAPIO 1.PNG", "/Vigna .PNG", "/LOGO OK .PNG", "/foto-2.jpg", "/foto-3.jpg"]
  },
  tours: [
    {
      id: 1,
      image: "/ponte principe LAPIO 1.PNG",
      price: "50",
      link: "#contatti",
      itinerario: true,
      vini: [
        { icon: "🍷", nome: "Lapio", docg: "Fiano di Avellino DOCG" },
        { icon: "🍷", nome: "Taurasi", docg: "Taurasi DOCG" },
        { icon: "🍷", nome: "Tufo", docg: "Greco di Tufo DOCG" }
      ]
    },
    {
      id: 2,
      image: "/LAPIO 3.PNG",
      overlayText: "WINE & BIKE",
      link: "https://wa.me/393273183597?text=Vorrei%20prenotare%20il%20tour%20con%20degustazione",
      vini: [
        { icon: "🥂", nome: "Calice 1", docg: "Fiano di Avellino DOCG" },
        { icon: "🍷", nome: "Calice 2", docg: "Aglianico DOC" },
        { icon: "🍇", nome: "Calice 3", docg: "Deciso dal proprietario" }
      ]
    }
  ],
  bikes: [
    {
      id: 1,
      name: "Atala E-Run 7.1",
      img: "/Atala .PNG",
      pricing: {
        daily: { price: "€25", discount: "0%" },
        twoDays: { price: "€45", discount: "10%" },
        threeDays: { price: "€60", discount: "20%" },
        fiveDays: { price: "€90", discount: "28%" },
        sevenDays: { price: "€110", discount: "37%" },
        monthly: { price: "€250", discount: "67%" },
        notes: "Casco incluso nel prezzo."
      }
    },
    {
      id: 2,
      name: "SCOTT Aspect 930",
      img: "/scott.png",
      pricing: {
        daily: { price: "€20", discount: "0%" },
        twoDays: { price: "€35", discount: "12%" },
        threeDays: { price: "€50", discount: "17%" },
        fiveDays: { price: "€75", discount: "25%" },
        sevenDays: { price: "€90", discount: "35%" },
        monthly: { price: "€200", discount: "67%" },
        notes: "Bici muscolare. Casco incluso."
      }
    },
    {
      id: 3,
      name: "Giant Fathom E+ 3",
      img: "/GIANT .PNG",
      pricing: {
        daily: { price: "€35", discount: "0%" },
        twoDays: { price: "€65", discount: "6%" },
        threeDays: { price: "€92", discount: "12%" },
        fiveDays: { price: "€140", discount: "20%" },
        sevenDays: { price: "€183", discount: "25%" },
        monthly: { price: "€400", discount: "62%" },
        notes: "E-MTB Professionale. Casco incluso."
      }
    },
    {
      id: 4,
      name: "Nilox K3 MID",
      img: "/Nilox .PNG",
      pricing: {
        daily: { price: "€40", discount: "0%" },
        twoDays: { price: "€75", discount: "6%" },
        threeDays: { price: "€105", discount: "12%" },
        fiveDays: { price: "€160", discount: "20%" },
        sevenDays: { price: "€210", discount: "25%" },
        monthly: { price: "€450", discount: "62%" },
        notes: "E-MTB Full-Suspension. Casco incluso."
      }
    }
  ],
  galleryImages: [
    { src: "/BIG BENCH .PNG", alt: "Grande Panchina" },
    { src: "/PALAZZO 1.PNG", alt: "Palazzo Filangieri" },
    { src: "/PALAZZO 2.PNG", alt: "Interni Palazzo" },
    { src: "/ponte principe LAPIO 2.PNG", alt: "Ponte Principe" },
    { src: "/Vigna .PNG", alt: "Vigneti" }
  ],
  contatti: {
    indirizzo: "Contrada Arianiello 9, Lapio (AV)",
    email: "bikeirpinia@gmail.com"
  }
};
